import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectDeviceById, setBanId, setEditId } from "../../../store/mine_craft/devicesSlice";
import { fetchDevice } from "../../../actions/mine_craft/devicesActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "../../../componets/SummaryShow";
import Tabs from "../../../componets/Tabs";
import SidebarShow from "./_partials/_SidebarShow";
import Sessions from "./_partials/_Sessions";
import Edit from "./Edit";
import Block from "./Block";
import { Button, ButtonEdit } from "../../../componets/Buttons";
import { StopOutlined } from "@ant-design/icons";
import Title from "./_partials/_Title";
import configs from "../../../configs/configs.json";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const device = useAppSelector(state => id ? selectDeviceById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchDevice(id));
    }
  }, [id, dispatch]);

  function onClickBan() {
    if (device) {
      dispatch(setBanId(device.id));
    }
  }

  function onClickEdit() {
    if (device) {
      dispatch(setEditId(device.id));
    }
  }

  const renderDeviceType = () => {
    if (!device) {
      return undefined;
    }

    if(device.device_type === 'iPad') {
      return configs.IMAGES.TABLET_SVG;
    } else {
      return configs.IMAGES.MOBILE_SVG;
    }
  }

  return (
    <PageLayout className='v-devices-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            device &&
              <SummaryShow
                title={<Title name={device.id} bannedUntil={device.banned_until} />}
                subtitle={device.vendor}
                createdAt={device.created_at}
                updatedAt={device.updated_at}
                image={renderDeviceType()}
                actions={[
                  <Button key='button-ban' onClick={onClickBan} title='Block' icon={StopOutlined} />,
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                ]}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Sessions', key: 'sessions', children: <Sessions deviceId={device?.id} /> },
            ]}
          />
        </div>
      </div>

      <Edit />
      <Block />
      <SidebarShow device={device} />
    </PageLayout>
  )
}

export default Show;
